import { useMemo, useState, useContext } from "react";
import { RevertIcon } from "../../assets/images/svg/svg";
import { Link } from "react-router-dom";
import {
  tableIndexNumber,
  totalPages,
  parenthesisInNegativeValue,
  HandleError,
} from "../../utils/services";
import { usePaymentChequeList } from "../../api/get";
import { ChequeListResponse } from "../../api/types";
import { Table } from "../CustomReactTable/CustomReactTable";
import ChequeListCard from "./ChequeListCard/ChequeListCard";
import { Search } from "../../api/get/types";
import { PopupContext } from "../PopUp/Popup-Context";
import { PopUp } from "../PopUp/PopUp";
import { PasswordPopup } from "../PopUp/PasswordPopup";
import { ConfirmationPopup } from "../PopUp/ConfirmationPopup";
import { RevertPaymentChequeList } from "../../api/post";
import { useToast } from "../../context/ToasterContext/ToasterContext";
import { NoDataPage } from "../NoDataPage/NoDataPage";
import { Loader } from "../Loader/Loader";

interface ViewAlProps {
  viewAll: boolean;
}
type PopUpTypes = "cancel" | "deposit";

export const PaymentVoucherChequeList: React.FC<ViewAlProps> = ({
  viewAll,
}) => {
  const [queryPageIndex, setQueryPageIndex] = useState(0);
  const [queryPageSize, setQueryPageSize] = useState(() => (viewAll ? 10 : 5));
  const [searchTerm, setSearchTerm] = useState<Search>({ cheque_no: "" });

  //useQuery
  const {
    data: chequeList,
    isLoading,
    refetch,
  } = usePaymentChequeList(queryPageIndex, queryPageSize, searchTerm as Search);
  const { openModal, closeModal } = useContext(PopupContext);
  const [cancelPopup, setCancelPopUp] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [passwordPopup, setPasswordPopup] = useState(false);
  const [reason, setReason] = useState("");
  const { showErrorMessage, showSuccessMessage } = useToast();
  const [popupType, setPopupType] = useState<PopUpTypes>();

  const handleRevert = (value: { id: string; status: string }) => {
    if (value.status === null) {
      openModal();
      setCancelPopUp(false);
      setPasswordPopup(true);
      setSelectedId(value.id);
      setPopupType("cancel");
    }
  };

  const FormatTable = (
    array: ChequeListResponse[],
    pageIndex: number,
    pageSize: number,
  ) => {
    if (array) {
      const formatData = array?.map((item, index) => {
        return {
          s_n: tableIndexNumber(pageIndex, pageSize, index),
          date: item?.miti,
          cheque_no: item?.cheque_no,
          bill_number: item?.bill_number,
          name: item?.user_info?.name ? item?.user_info?.name : "-",
          mobile_no: item?.user_info?.mobile_no
            ? item?.user_info?.mobile_no
            : "-",
          amount: parenthesisInNegativeValue(item?.amount),
          status: item?.status,
          action: {
            id: item.document_number,
            status: item.status,
          },
        };
      });
      return formatData;
    }
    return [];
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.N",
        accessor: "s_n",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      { Header: "Cheque No", accessor: "cheque_no" },
      { Header: "Bill No", accessor: "bill_number" },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile No.",
        accessor: "mobile_no",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }: { value: string }) => {
          return (
            <>
              {value ? (
                <div className={`status-section ${value.toLowerCase()}`}>
                  {value}
                </div>
              ) : (
                "-"
              )}
            </>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({
          value,
        }: {
          value: {
            id: string;
            status: string;
          };
        }) => {
          return (
            <div className="action-section">
              <div
                className={
                  value?.status === null
                    ? "line-primary gap-2"
                    : "line-default gap-2"
                }
                onClick={() => {
                  handleRevert(value);
                }}
              >
                <span className="mg-right-10 ">
                  <RevertIcon />
                </span>
                Revert
              </div>
            </div>
          );
        },
      },
    ],
    [],
  );

  const billCancelation = (reason: string, selectedId: string) => {
    if (!reason) {
      showSuccessMessage("Please specify reason");
      closeModal();

      return;
    }
    const data = {
      reason_to_revert: reason,
    };
    const PostApi = RevertPaymentChequeList;
    PostApi(selectedId, data)
      .then((res) => {
        showSuccessMessage("Payment Voucher Cheque cancelled successfully");
        refetch();
        closeModal();
      })
      .catch((err) => {
        let erroMessage = "";
        if (err.response.data) {
          erroMessage = HandleError(err);
        }
        showErrorMessage(erroMessage || "Something went wrong");
      });
  };

  return (
    <>
      <div className="dashboard-table card-height">
        {!viewAll ? (
          <>
            {isLoading ? (
              <Loader loaderType="Spinner" />
            ) : chequeList && chequeList?.data.length > 0 ? (
              <>
                {chequeList?.data
                  ?.slice(0, 3)
                  ?.map((item: any, index: number) => (
                    <ChequeListCard
                      document_number={chequeList?.data[index]?.bill_number}
                      cheque_no={chequeList?.data[index]?.cheque_no}
                      miti={chequeList?.data[index]?.miti}
                      logo={chequeList?.data[index]?.user_info?.name?.slice(
                        0,
                        1,
                      )}
                      name={chequeList?.data[index]?.user_info?.name}
                      mobile={chequeList?.data[index]?.user_info?.mobile_no}
                      amount={chequeList?.data[index]?.amount}
                      status={chequeList?.data[index]?.status}
                      isPurchasePayment={true}
                      handleRevertPopup={() => {
                        const value = {
                          id: item?.document_number,
                          status: item?.status,
                        };
                        handleRevert(value);
                      }}
                    />
                  ))}

                <Link to={`/payment-cheque-list`} className="view-btn">
                  <button
                    type="button"
                    className="content light-secondary next small-button "
                  >
                    View All
                  </button>
                </Link>
              </>
            ) : (
              <NoDataPage description="Looks like there are no entries here yet" />
            )}
          </>
        ) : (
          <>
            <div className="head-section">
              <p className="small-title">Payment Voucher Cheque List</p>
            </div>
            <Table
              excelDownload={true}
              loading={isLoading}
              columns={columns}
              data={
                chequeList
                  ? FormatTable(chequeList.data, queryPageIndex, queryPageSize)
                  : []
              }
              totalPages={
                chequeList &&
                totalPages(queryPageSize, chequeList.pagination.total_count)
              }
              totalEntries={chequeList && chequeList.pagination.total_count}
              queryPageIndex={queryPageIndex}
              setQueryPageIndex={setQueryPageIndex}
              queryPageSize={queryPageSize}
              setQueryPageSize={setQueryPageSize}
              showPageSize={false}
              searchArray={["cheque_no"]}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </>
        )}
      </div>
      {passwordPopup && (
        <PopUp
          title="Sign-In Required"
          showCrossIcon={true}
          renderComponent={
            <PasswordPopup
              setPasswordPopup={setPasswordPopup}
              setCancelPopUp={setCancelPopUp}
            />
          }
        />
      )}
      {cancelPopup && (
        <>
          <PopUp
            title="Confirmation"
            renderComponent={
              <ConfirmationPopup
                handleCancel={() => {
                  billCancelation(reason, selectedId as string);
                  setCancelPopUp(false);
                }}
                showReasonField={true}
                reason={reason}
                setReason={setReason}
                confirmationQuestion={`Are you sure you want to cancel ${
                  selectedId || ""
                }?`}
              />
            }
          />
        </>
      )}
    </>
  );
};
